export default __webpack_public_path__ + "static/media/apartment-card-money-icon.1a6ed890.svg";